export var LiabilityType;
(function (LiabilityType) {
    LiabilityType["Vehicle"] = "CAR_LOAN";
    LiabilityType["HomeLoan"] = "HOME_LOAN";
    LiabilityType["CreditCard"] = "CREDIT_CARD";
    LiabilityType["StoreCard"] = "STORE_CARD";
    LiabilityType["PersonalLoan"] = "PERSONAL_LOAN";
    LiabilityType["ShortTermFinance"] = "SHORT_TERM_FINANCE";
    LiabilityType["Lease"] = "LEASE";
    LiabilityType["HirePurchase"] = "HIRE_PURCHASE";
    LiabilityType["TaxDebt"] = "TAX_DEBT";
    LiabilityType["LineOfCredit"] = "LINE_OF_CREDIT";
    LiabilityType["Overdraft"] = "OVERDRAFT";
    LiabilityType["HelpHecsDebt"] = "HELP_HECS_DEBT";
    LiabilityType["Other"] = "OTHER";
    LiabilityType["Unknown"] = "UNKNOWN";
})(LiabilityType || (LiabilityType = {}));
export var LiabilityRepaymentTypeDetails;
(function (LiabilityRepaymentTypeDetails) {
    LiabilityRepaymentTypeDetails["InterestOnly"] = "INTEREST_ONLY";
    LiabilityRepaymentTypeDetails["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
})(LiabilityRepaymentTypeDetails || (LiabilityRepaymentTypeDetails = {}));
export var LiabilityRepaymentFrequency;
(function (LiabilityRepaymentFrequency) {
    LiabilityRepaymentFrequency["Weekly"] = "WEEKLY";
    LiabilityRepaymentFrequency["Fortnightly"] = "FORTNIGHTLY";
    LiabilityRepaymentFrequency["Monthly"] = "MONTHLY";
    LiabilityRepaymentFrequency["Annually"] = "ANNUALLY";
})(LiabilityRepaymentFrequency || (LiabilityRepaymentFrequency = {}));
export var LiabilityClearingFromOtherSource;
(function (LiabilityClearingFromOtherSource) {
    LiabilityClearingFromOtherSource["PayingOut"] = "PAYING_OUT";
    LiabilityClearingFromOtherSource["Reducing"] = "REDUCING";
})(LiabilityClearingFromOtherSource || (LiabilityClearingFromOtherSource = {}));
export var LiabilityInterestType;
(function (LiabilityInterestType) {
    LiabilityInterestType["FixedRate"] = "FIXED_RATE";
    LiabilityInterestType["Variable"] = "VARIABLE";
})(LiabilityInterestType || (LiabilityInterestType = {}));
//# sourceMappingURL=Liabilities.js.map